module.exports = __webpack_public_path__ + "static/media/desc.2569c967.png";